import {Drawer, List, ListItemText, ListItem,
    Collapse,
    ListItemButton} from "@mui/material";
import ExpandLess from '@mui/icons-material/ExpandLess';
import { useEffect } from "react";
import ExpandMore from '@mui/icons-material/ExpandMore';
import {
    Home as HomeIcon,
    HomeWork as HomeWorkIcon,
    CalendarToday as CalendarTodayIcon,
    EditCalendar as EditCalendarIcon,
    CalendarMonth as CalendarMonthIcon,
    LocalOffer as LocalOfferIcon,
    Group as GroupIcon,
    MenuBook as MenuBookIcon,
    BarChart as BarChartIcon
  } from "@mui/icons-material";
import React, {useState} from "react";
import { ListItemLink } from "../ListItemLink";
import {connect} from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {closeMenu} from "../../modules/root/root.actions";
import {withTranslation} from "react-i18next";
import {
    hasPermission,
    PERMISSION_AREAS,
    PERMISSION_CONTENT_IDENTIFIERS,
    PERMISSION_FUNCTIONS,
    PERMISSION_LOCATIONS, PERMISSION_REPORTS,
    PERMISSION_SYSTEM_LOG,
    PERMISSION_USERS,
    PERMISSION_VIEW_ONLY_FUNCTIONS
} from "../../permissions";

const mapStateToProps = state => {
    return {
        mobileOpen: state.root.mobileOpen,
        leftDrawerOpen: state.root.leftDrawerOpen,
        breadcrumbs: state.root.breadcrumbs,
        authenticatedUser: state.auth.authenticatedUser,
    };

}
const mapDispatchToProps = dispatch => {
    return {
        closeMenu: () => dispatch(closeMenu())
    };
}


const LeftDrawerComponent = (props) => {
    const isActive = (path) => {
        if (props.breadcrumbs.length < 1) {
            return false;
        }
        const last = props.breadcrumbs[props.breadcrumbs.length - 1];
        return last.path === path;
    }

    const {t} = props;
    const links = []
    const location = useLocation();
    const navigate = useNavigate()

    if (hasPermission(PERMISSION_AREAS, props.authenticatedUser)) {
        links.push({
            path: "/municipality",
            label: t('common.areas'),
            icon: <HomeIcon />
        });
    }
    if (hasPermission(PERMISSION_LOCATIONS, props.authenticatedUser)) {
        links.push({
            path: "/location",
            label: t('common.locations'),
            icon: <HomeWorkIcon />
        });
    }


    const [functionsOpen, setFunctionsOpen] = useState(false);

    const handleFunctionsClick = () => {
        setFunctionsOpen(!functionsOpen);
    };

    useEffect(() => {
        if (["/function"].some(prefix => location.pathname.startsWith(prefix))) {
            setFunctionsOpen(true);
        }
    }, [location.pathname]);

    if (hasPermission(PERMISSION_FUNCTIONS, props.authenticatedUser)) {
        const hasViewPermission = hasPermission(PERMISSION_VIEW_ONLY_FUNCTIONS, props.authenticatedUser);
        links.push({
            path: "/function",
            label: t('common.functions'),
            icon: <CalendarTodayIcon />,
            ...(!hasViewPermission ? {
                children: [
                    {
                        path: "/function/createFunction",
                        label: t('common.creating_functions'),
                        icon: <EditCalendarIcon />
                    },
                    {
                        path: "/function/functionTemplates",
                        label: t('common.function_templates'),
                        icon: <CalendarMonthIcon />
                    }
                ]
            } : {}),
            open: functionsOpen,
            click: handleFunctionsClick
        });
    }
    
    if (hasPermission(PERMISSION_CONTENT_IDENTIFIERS, props.authenticatedUser)) {
        links.push({
            path: "/contentIdentifier",
            label: t('common.content_identifiers'),
            icon: <LocalOfferIcon />
        });
    }
    if (hasPermission(PERMISSION_USERS, props.authenticatedUser)) {
        links.push({
            path: "/user",
            label: t('common.users'),
            icon: <GroupIcon />
        });
    }
    if (hasPermission(PERMISSION_SYSTEM_LOG, props.authenticatedUser)) {
        links.push({
            path: "/systemLog",
            label: t('common.system_logs'),
            icon: <MenuBookIcon />
        });
    }
    if (hasPermission(PERMISSION_REPORTS, props.authenticatedUser)) {
        links.push({
            path: "/report",
            label: t('common.reports'),
            icon: <BarChartIcon />
        });
    }
    //Using react router SPA navigation now.
    const handleNavClick = (e, path) => {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();
        navigate(path);
    };

    return (
        <Drawer
            className={`leftDrawer ${props.mobileOpen && props.leftDrawerOpen ? 'active' : ''}`}
            variant="permanent"
            classes={{
                paper: 'leftDrawerPaper'
            }}
        >
            <List className={'drawer-list-new left-drawer-list drawer-list'}>
                    {
                        links.map(({path, label, children, icon, open, click}, index) => {
                            const parentIndex = index;
                            return (
                                <React.Fragment key={`item-link-${index}-fragment`}>
                                    <ListItem key={`item-link-${index}`} className="left-drawer-item">
                                        {icon}
                                        <ListItemLink key={`item-link-${index}-link`}  href={path} onClick={(e) => handleNavClick(e, path)}
                                                      className={`leftListItemLink ${isActive(path) ? 'active' : ''}`}>
                                            <ListItemText primary={label}/>
                                        </ListItemLink>
                                        {children && <ListItemButton aria-label="Expand section" key={`item-link-${index}-button`} onClick={click}>
                                            {open ? <ExpandLess key={`item-link-${index}-less`} /> : <ExpandMore  key={`item-link-${index}-more`} />}
                                        </ListItemButton>}
                                    </ListItem>
                                    {children &&
                                        <Collapse className="left-drawer-parent" key={`item-link-${parentIndex}-collapse`} in={open} timeout={0} unmountOnExit>
                                            <List className="left-drawer-wrapper" key={`item-link-${parentIndex}-collapse-list`}>
                                            {children.map(
                                                ({path, label, icon}, index) => (
                                                <ListItem key={`item-link-${index}`} className="left-drawer-item">
                                                    <ListItemLink key={`item-link-${parentIndex}-${index}`} href={path} onClick={(e) => handleNavClick(e, path)}>
                                                        {icon}
                                                        <ListItemText primary={label}/>
                                                    </ListItemLink>
                                                </ListItem>
                                                ))
                                            }
                                            </List>
                                        </Collapse>
                                    }
                                </React.Fragment>
                            )}
                        )
                    }
            </List>
        </Drawer>
    );
}

const LeftDrawerNew = connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation('translation')(LeftDrawerComponent));
export {LeftDrawerNew};